module.exports = __webpack_public_path__ + "static/media/lena@3x.d0690259.png";